import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './help-center.css'

const HelpCenter = (props) => {
  return (
    <div className="help-center-container1">
      <Helmet>
        <title>HelpCenter - Copy of iCharge web copy 2</title>
        <meta
          property="og:title"
          content="HelpCenter - Copy of iCharge web copy 2"
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="help-center-text10">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="help-center-text11">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="help-center-text12">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="help-center-text13">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="help-center-text14">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="help-center-text15">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="help-center-text16">Cultivating Connection</span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="help-center-text17">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="help-center-text21">How to charge</span>
          </Fragment>
        }
        rootClassName="navbarroot-class-name"
        chargingPointLink1={
          <Fragment>
            <span className="help-center-text22">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="help-center-text23">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <main className="help-center-main column align-center full-vertical-height justify-center full-width thq-section-padding">
        <div className="column align-center full-width max-content-width gap-10 help-center-max-width">
          <div className="help-center-container2 column align-center gap-2-5">
            <h1 className="help-center-text24 heading-1">Help Center</h1>
            <p className="help-center-text25 sub-heading-1">
              Contact us for questions, complaints, or suggestions. Our support
              team is always ready to provide fast and accurate
              solutions—without complications.
            </p>
          </div>
          <div className="help-center-container3 row align-center full-width gap-3-5">
            <form className="help-center-form">
              <textarea
                placeholder="Type your message here"
                className="help-center-textarea textarea"
              ></textarea>
              <a
                href="https://mail.google.com/mail/?view=cm&amp;to=support@icharge.app&amp;su=Hello&amp;body=Hi%20there"
                target="_blank"
                rel="noreferrer noopener"
                className="help-center-link thq-button-animated thq-button-outline"
              >
                Send
              </a>
            </form>
            <img
              alt="image"
              src="/Pages/Help Center/63032ceb-5bd5-40db-8be2-cef63a516f9a-500w.webp"
              className="help-center-image"
            />
          </div>
        </div>
      </main>
      <Footer rootClassName="footerroot-class-name"></Footer>
    </div>
  )
}

export default HelpCenter
